module.exports = __webpack_public_path__ + "img/img_6.0d65d8e0.jpg";